import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound   from '@/components/ui/tables/IsLoadingNotFound';

/* column definition – plain text */
const tableColumn = [
  { name:'Name'    },
  { name:'Email'   },
  { name:'Phone'   },
  { name:'Balance' },
];

export default function DataTable({
  isLoading, dataSource, totalRecord, dataFilter, onChangePage,
}) {
  return (
    <TableWrapServerSide
      tableColumnList={tableColumn}
      totalDataCount ={totalRecord}
      initialPage    ={dataFilter.page}
      per_page       ={dataFilter.limit}
      onChangePage   ={onChangePage}
    >
      {dataSource.length ? (
        dataSource.map(r => (
          <tr className="db-table-body-tr" key={r._id || r.id}>
            <td className="db-table-body-td">{r.name}</td>
            <td className="db-table-body-td">{r.email}</td>
            <td className="db-table-body-td">{r.phone}</td>
            <td className="db-table-body-td">{r.balance}</td>
          </tr>
        ))
      ) : (
        <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
      )}
    </TableWrapServerSide>
  );
}
